import { CreatekfAccountDataType } from "pages/apps/Adaccount/types";
import axios from 'axios';

interface AuthParams {
  suite_id: string;
  auth_type: string;
}

interface KfAccountParams {
  limit: string;
  corp_id: string;
}

interface UploadMediaParams {
  type: string
  corp_id: string
}

interface DeletekfAccount {
  corpId: string
  name: string
  mediaId: string
}

interface WxUserParams {
  corp_id: string
  page: number
  pageSize: number
  search: string
}

export const authorizedEnterpriseWeChat = () => {
  const params: AuthParams = {
    suite_id: 'wwc1e681a5f35486da',
    auth_type: 'AUTH_TYPE_WXWORK_KF',
  };
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + '/api/v1/wxwork/auth_url?' + new URLSearchParams(params as any)).then(res => {
    return res.json()
  })
  return response
}

export const listKfAccounts = (corp_id: string) => {
  const params: KfAccountParams = {
    limit: '100',
    corp_id: corp_id,
  };
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + '/api/v1/wxwork/kf_account_list?' + new URLSearchParams(params as any)).then(res => {
    return res.json()
  })
  return response
}

export const uploadMedia = (corp_id: string, media: File) => {
  const params: UploadMediaParams = {
    type: 'image',
    corp_id: corp_id,
  };

  const url = process.env.REACT_APP_ORDERS_API_URL +
    `/api/v1/wxwork/upload_media?${new URLSearchParams(params as any).toString()}`;

  const formData = new FormData();
  formData.append('media', media);

  let response = fetch(url, {
    method: 'POST',
    body: formData,
  })
    .then((res) => {
      return res.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });

  return response;
};

export const createkfAccount = (data: CreatekfAccountDataType) => {
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + `/api/v1/wxwork/create_kf_account`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.json()
  })
  return response
}

export const deletekfAccount = (open_kfid: string, data: DeletekfAccount) => {
  const params = {
    open_kfid
  }
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + '/api/v1/wxwork/delete_kf_account?' + new URLSearchParams(params as any), {
    method: 'DELETE',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.json()
  })
  return response
}

export const listCorpCustomerAcquisition = (enterprise_id?: number, query?: string) => {
  const params: any = {
    enterprise_id,
    limit: 100,
  };

  if (query) {
    params.query = query
  }

  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + '/api/v1/wxwork/list_corp_customer_acquisition?' + new URLSearchParams(params as any)).then(res => {
    return res.json()
  })
  return response
}

export const assignToEnterprise = (corpId: string, enterpriseId?: number) => {
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + `/api/v1/wxwork/assign`, {
    method: 'POST',
    body: JSON.stringify({ "corpId": corpId, "enterpriseId": enterpriseId }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.json()
  })
  return response
}

export const asyncEnterprise = (enterpriseId?: number, corpId?: string) => {
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + `/api/v1/wxwork/sync`, {
    method: 'POST',
    body: JSON.stringify({ "enterpriseId": enterpriseId, "corpIds": [corpId] }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.json()
  })
  return response
}

export const importCorp = (corp_id: string) => {
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + `/api/v1/wxwork/import_corp`, {
    method: "POST",
    body: JSON.stringify({ "corp_id": corp_id }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.json()
  })
  return response
}

export const listWxUsers = (corp_id: string, page: number = 1, pageSize: number = 20, search: string = '') => {
  const params: WxUserParams = {
    // limit: '100',
    corp_id: corp_id,
    page,
    pageSize,
    search,
  };
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + '/api/v1/wxwork/list_wx_users?' + new URLSearchParams(params as any)).then(res => {
    return res.json()
  })
  return response
}

export const setWxUserOnline = (corp_id: string, userIds: string[]) => {
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + `/api/v1/wxwork/wx_user/online`, {
    method: "POST",
    body: JSON.stringify({ "corpId": corp_id, "userIds": userIds }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.json()
  })
  return response
}

export const setWxUserOffline = (corp_id: string, userIds: string[]) => {
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + `/api/v1/wxwork/wx_user/offline`, {
    method: "POST",
    body: JSON.stringify({ "corpId": corp_id, "userIds": userIds }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.json()
  })
  return response
}

export const getTreeWxDepartment = (corp_id: string) => {
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + `/api/v1/wxwork/list_department_tree?corpId=${corp_id}`, {
    method: "PATCH",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ "corpId": corp_id }),
  }).then(res => {
    return res.json()
  })
  return response
}

export const searchUser = (corp_id: string, search: string) => {
  let response = fetch(process.env.REACT_APP_ORDERS_API_URL + `/api/v1/wxwork/search_user?corpId=${corp_id}&search=${search}`, {
    method: "GET",
  }).then(res => {
    return res.json()
  })
  return response
}